function n(n){return n}export{n as identity};
